// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AARP","newExpiryDate":"styles_newExpiryDate__1C5C3","footer":"styles_footer__6WPd1"};